<template>
  <base-modal
    hide-footer
    :closeable-from-outside="false"
    :size="'xl'"
    :modal-id="'code-template-modal'"
    @hidden="$emit('onCloseModal')"
    @show="() => {}"
  >
    <b-form @submit.prevent="setTemplate">
      <div class="header-name">Select Code Template</div>
      <div class="line-bottom"></div>
      <b-row class="template-wrp d-flex flex-wrap mt-2">
        <div class="template1 mb-2 margin-template">
          <div>
            <input
              id="template1"
              v-model="formModal.templateSelect"
              type="radio"
              class="input-checkbox p-absolute"
              name="template"
              value="1"
            />
            <label for="template1" class="checkbox-checked-wrp">
              <template-1 class="checkbox-checked" :templateData="formModal" />
              <div class="mt-1 d-flex justify-content-center align-item-center">
                <div>
                  <div class="radio-outter-wrp">
                    <div class="radio-inner-wrp"></div>
                  </div>
                </div>

                <div class="ml-2 title-radio">Template 1</div>
              </div>
            </label>
          </div>
        </div>
        <div class="template2 mb-2 margin-template">
          <div>
            <input
              id="template2"
              v-model="formModal.templateSelect"
              type="radio"
              class="input-checkbox p-absolute"
              name="template"
              value="2"
            />
            <label for="template2" class="checkbox-checked-wrp">
              <template-2 class="checkbox-checked" :templateData="formModal" />
              <div class="mt-1 d-flex justify-content-center align-item-center">
                <div class="radio-outter-wrp">
                  <div class="radio-inner-wrp"></div>
                </div>
                <div class="ml-2 title-radio">Template 2</div>
              </div>
            </label>
          </div>
        </div>
        <div class="template3 mb-2 margin-template">
          <div>
            <input
              id="template3"
              v-model="formModal.templateSelect"
              type="radio"
              class="input-checkbox p-absolute"
              name="template"
              value="3"
            />
            <label for="template3" class="checkbox-checked-wrp">
              <template-type-3
                class="checkbox-checked"
                :templateData="formModal"
              />
              <div class="mt-1 d-flex justify-content-center align-item-center">
                <div class="radio-outter-wrp">
                  <div class="radio-inner-wrp"></div>
                </div>
                <div class="ml-2 title-radio">Template 3</div>
              </div>
            </label>
          </div>
        </div>
        <!-- <div class="template3 mb-2 margin-template">
          <div>
            <input
              id="template3"
              v-model="formModal.templateSelect"
              type="radio"
              class="input-checkbox"
              name="template"
              value="3"
            />
            <label for="template3" class="checkbox-checked-wrp">
              <template-3 class="checkbox-checked" :templateData="formModal"/>
              <div class="mt-1 d-flex justify-content-center align-item-center">
                <div class="radio-outter-wrp">
                  <div class="radio-inner-wrp"></div>
                </div>
                <div class="ml-2 title-radio">Template 3</div>
              </div>
            </label>
          </div>
        </div>
        <div class="template4 mb-2 margin-template">
          <div>
            <input
              id="template4"
              v-model="formModal.templateSelect"
              type="radio"
              class="input-checkbox"
              name="template"
              value="4"
            />
            <label for="template4" class="checkbox-checked-wrp">
              <template-4 class="checkbox-checked" :templateData="formModal"/>
              <div class="mt-1 d-flex justify-content-center align-item-center">
                <div class="radio-outter-wrp">
                  <div class="radio-inner-wrp"></div>
                </div>
                <div class="ml-2 title-radio">Template 4</div>
              </div>
            </label>
          </div>
        </div>
        <div class="template5 mb-2 margin-template">
          <div>
            <input
              id="template5"
              v-model="formModal.templateSelect"
              type="radio"
              class="input-checkbox"
              name="template"
              value="5"
            />
            <label for="template5" class="checkbox-checked-wrp">
              <template-5 class="checkbox-checked" :templateData="formModal"/>
              <div class="mt-1 d-flex justify-content-center align-item-center">
                <div class="radio-outter-wrp">
                  <div class="radio-inner-wrp"></div>
                </div>
                <div class="ml-2 title-radio">Template 5</div>
              </div>
            </label>
          </div>
        </div> -->
      </b-row>
      <div class="code-template-modal-wrp mt-3 mb-3">
        <div class="d-flex justify-content-center">
          <cancel-button class="mr-1" @click.native="$emit('onCloseModal')" />
          <b-button class="btn-next ml-2" :type="'submit'">
            <div class="d-flex align-items-center justify-content-center">
              <span>{{ "Next" }}</span>
            </div>
          </b-button>
        </div>
      </div>
    </b-form>
  </base-modal>
</template>

<script>
import BaseModal from "@/@core/components/base-modal/BaseModal.vue";
import IconDataManagement from "@/@core/components/svg/nav-bar/IconDataManagement.vue";
import Template1 from "./template/Template1.vue";
import Template2 from "./template/Template2.vue";
import Template3 from "./template/Template3.vue";
import TemplateType3 from "./template/TemplateType3.vue";
import Template4 from "./template/Template4.vue";
import Template5 from "./template/Template5.vue";

import useCodeTemplateModal from "../hooks/useCodeTemplateModal.js";

export default {
  components: {
    BaseModal,
    IconDataManagement,
    Template1,
    Template2,
    Template3,
    TemplateType3,
    Template4,
    Template5,
  },

  setup() {
    const { formModal, setTemplate } = useCodeTemplateModal();

    return {
      formModal,
      setTemplate,
    };
  },
};
</script>


<style scoped>
@import "~@/assets/css/pages/privilege/privilege-code-template/code-template-modal.css";

#code-template-modal .template-wrp {
  padding: 0px 60px;
}
</style>